import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from './HtmlContent';
import LiquidContent from './LiquidContent';
import PlainContent from './PlainContent';
import QuillContent from './QuillContent';

/* Fast content types can be rendered as many times as desired without
 * significant performance impacts. Slow content types should be
 * limited to the 10s per page.
 */

export const CONTENT_TYPE_FAST = {
  PLAIN: 'PLAIN',
  HTML: 'HTML',
};

export const CONTENT_TYPE_SLOW = {
  QUILL: 'QUILL',
  LIQUID: 'LIQUID',
};

export const CONTENT_TYPE = {
  ...CONTENT_TYPE_FAST,
  ...CONTENT_TYPE_SLOW,
};


const propTypes = {
  carrierId: PropTypes.number,
  edit: PropTypes.bool,
  inherit: PropTypes.bool, /* Inherit styles from parent */
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onSelectChange: PropTypes.func,
  type: PropTypes.oneOf(Object.values(CONTENT_TYPE)).isRequired,
  value: PropTypes.string,
  displayTypeSelect: PropTypes.bool,
  dropDownOptions: PropTypes.arrayOf(PropTypes.object),
  indexOfContentType: PropTypes.number,
};

const defaultProps = {
  carrierId: null,
  edit: false,
  inherit: false,
  onChange: null,
  onSave: null,
  onCancel: null,
  onSelectChange: null,
  displayTypeSelect: false,
};


export default function Content({ type, ...rest }) {
  switch (type) {
    case CONTENT_TYPE.HTML:
      return <HtmlContent {...rest} />;
    case CONTENT_TYPE.LIQUID:
      return <LiquidContent {...rest} />;
    case CONTENT_TYPE.PLAIN:
      return <PlainContent {...rest} />;
    case CONTENT_TYPE.QUILL:
      return <QuillContent {...rest} />;
    default:
      return 'Unrecognized content type';
  }
}

Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
